import { render, staticRenderFns } from "./NbhdList.vue?vue&type=template&id=ed6bd9e2&scoped=true&"
import script from "./NbhdList.vue?vue&type=script&lang=js&"
export * from "./NbhdList.vue?vue&type=script&lang=js&"
import style0 from "./NbhdList.vue?vue&type=style&index=0&id=ed6bd9e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6bd9e2",
  null
  
)

export default component.exports